import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { LoadingSpaceType } from './../../../../core/types';

@Component({
    selector: 'gl-loading-space-list-element',
    templateUrl: './loading-space-list-element.component.html',
    styleUrls: ['./loading-space-list-element.component.scss'],
    standalone: false
})
export class LoadingSpaceListElementComponent {
  @Output() public chosen: EventEmitter<LoadingSpaceType> = new EventEmitter<LoadingSpaceType>();
  @Output() public edit: EventEmitter<LoadingSpaceType> = new EventEmitter<LoadingSpaceType>();
  @Output() public addSpace: EventEmitter<LoadingSpaceType> = new EventEmitter<LoadingSpaceType>();
  @Input() public loadingSpace: LoadingSpaceType;
  @Input() public hoverActive: boolean;
  @Input() public isButtons = true;

  @HostListener('click')
  public onclick() {
    this.chosen.emit(this.loadingSpace);
  }

  @HostListener('mouseenter')
  public onMouseEnter() {
    if (this.hoverActive) {
      this.chosen.emit(this.loadingSpace);
    }
  }

  public addLoadingSpace(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.addSpace.emit(this.loadingSpace);
  }

  public editLoadingSpace(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.edit.emit(this.loadingSpace);
  }
}
